import { useState } from "react";

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: "《家庭教师》漫画真的可以免费阅读吗?",
    a: "是的!土豪漫画网的所有漫画,包括《家庭教师》全集 406 话,全部免费在线阅读,无需注册、无需付费,高清画质随点随读。",
  },
  {
    q: "在土豪漫画网阅读漫画需要下载 App 吗?",
    a: "不需要。土豪漫画网支持网页直接在线阅读,手机、平板、电脑浏览器均可访问,随时随地都能追更。",
  },
  {
    q: "《家庭教师》漫画多久更新一次?",
    a: "本站每日更新热门漫画的最新章节,更新内容会在首页「最新更新」板块实时展示,方便你第一时间追更。",
  },
  {
    q: "阅读漫画时可以调整字体或翻页方式吗?",
    a: "章节阅读页支持通过页面上方的章节下拉框快速切换章节,也支持「上一章 / 下一章」按钮逐话翻页,阅读体验流畅。",
  },
  {
    q: "找不到想看的漫画怎么办?",
    a: "你可以使用顶部导航的搜索框直接搜索漫画名称,或在「漫画分类」页按分类浏览。如果仍然找不到,欢迎通过「关于我们」页面的联系方式反馈给我们。",
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16" aria-labelledby="faq-heading">
      <div className="mx-auto max-w-3xl">
        <div className="mb-8 text-center">
          <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-sm font-medium text-accent-800">
            <i className="ri-question-line" aria-hidden="true" />
            常见问题
          </div>
          <h2 id="faq-heading" className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            阅读前常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">关于免费阅读与追更的一切,都在这里</p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  isOpen ? "border-primary-200 bg-background-50" : "border-background-200 bg-background-100/60"
                }`}
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    aria-expanded={isOpen}
                    aria-controls={`faq-panel-${index}`}
                  >
                    <span className="flex items-center gap-3 text-sm font-bold text-foreground-950">
                      <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-500"}`}>
                        {index + 1}
                      </span>
                      {item.q}
                    </span>
                    <i
                      className={`shrink-0 text-lg text-foreground-400 transition-transform ${isOpen ? "rotate-180 text-primary-500" : ""}`}
                      aria-hidden="true"
                    />
                  </button>
                </h3>
                <div
                  id={`faq-panel-${index}`}
                  role="region"
                  className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}
                >
                  <div className="overflow-hidden">
                    <p className="border-t border-background-200 px-5 py-4 pl-14 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}